/* src/app/main-game/main-game-finished/main-game-finished.component.scss */
/*# sourceMappingURL=main-game-finished.component.css.map */
